<template>
  <qc-dialog class="tc-15-rich-dialog cos" :show="innerShow" type="custom"
    :title="$t('core.failure_list_type',{type: $t(`core.${type}`)})" :width="620" @close="closeDialog">
    <qc-table min-height="0" max-height="400px" :list="showList" :empty-tips="$t('core.list_empty')" :page-size="1000"
      :default-page-size="1000">
      <qc-table-column :label="$t('core.file_name')" field="Key"></qc-table-column>
      <qc-table-column :label="$t('core.cause_of_failure')" field="Code">
        <template slot-scope="{ item }">
          <div>
            {{formatErrorMsg(item.Code||item.Error)}}
          </div>
        </template>
      </qc-table-column>

      <template slot="pagination" slot-scope="page">
        <qc-pagination v-if="page.totalNum > 1000" :total-num="page.totalNum" :page-size.sync="page.pageSize"
          :curr-page.sync="page.currPage" :min-page-size="1000" :max-page-size="1000" :page-size-step="1000">
        </qc-pagination>
        <!-- 为了避免插槽 fallback 回默认分页器，以下一行代码不可删除 -->
        <span style="display: none;"></span>
      </template>
    </qc-table>
  </qc-dialog>
</template>

<script>
import { getInnerProps, removeFromList } from 'tools/utils';
import eventProxy from 'tools/eventProxy';

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      showList: [],
      type: 'delete',
    };
  },
  computed: {
    innerShow: getInnerProps('show'),
  },
  mounted() {
    eventProxy.on('deleteFailed.show', this.initData);
  },
  destroyed() {
    eventProxy.off('deleteFailed.show', this.initData);
  },
  methods: {
    initData({
      totalList, failedList, successList, type,
    }) {
      this.innerShow = true;
      this.type = type;
      switch (type) {
        case 'delete': {
          const unFinishedList = removeFromList(
            [...failedList, ...successList],
            totalList,
          );
          this.showList = [...failedList, ...unFinishedList];
          break;
        }
        default: {
          this.showList = failedList;
          break;
        }
      }
      if (type === 'delete') {
        const unFinishedList = removeFromList(
          [...failedList, ...successList],
          totalList,
        );
        this.showList = [...failedList, ...unFinishedList];
      }
    },
    formatErrorMsg(error) {
      if (this.type === 'delete') {
        const code = error;
        return this.$t(`error.${code}`) || this.$t('core.delete_incomplete');
      }
      const code = error.code || error.Code;
      return window.lang.err(`error.${code}`, error);
    },
    closeDialog() {
      this.innerShow = false;
    },
  },
};
</script>
